module.exports = __webpack_public_path__ + "media/images/static/consult/cover-0ca9d50807a5001a11050b670f855a66.png";